import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, catchError, of } from 'rxjs';
import { StorageService } from 'src/app/_services/storage.service';
import { environment } from 'src/environments/environment';
const { API_URLBLAZE ,API_URLBLAZEOLD} = environment;
@Injectable({
  providedIn: 'root'
})
export class AuditTrailService {
    constructor(private http: HttpClient, private storageService: StorageService, private router: Router) { }

    //Get Audit Trail List
    getAuditTrailList(module:String,operation:String,entityKey:string,dateFrom:string,dateTo:string,pageSize:number,pageNumber:number) {
      var url = "";
      var filter = "";
      if(module != "" && module != null){
        filter = filter+`&entity=${module}`
      }
      if(operation != "" && operation != null){
        filter = filter+`&operation=${operation}`
      }
      if(entityKey != "" && entityKey != null){
        filter = filter+`&entityKey=${entityKey}`
      }
      if(dateFrom != "" && dateTo!=""){
        filter = filter+`&eventTimestamp=gte%3D${dateFrom}%24lte%3D${dateTo}`
      }
      
      url = `${API_URLBLAZEOLD}/audit-trail?page_size=${pageSize}&page_no=${pageNumber}&sort_dir=DESC&sort_column=eventTimestamp`+filter;
      return this.http.get(url).pipe(catchError(this.handleError()));
    }
      private handleError<T>(operation = 'operation', result?: T) {
        return (error: HttpErrorResponse): Observable<T> => {
          if (error.status == 401) {
            this.storageService.clean()
            this.router.navigate(['/auth/login']);
          }
          result = error?.error;
          return of(result as T);
        };
      }
}